import { connect } from 'react-redux';
import {
  createTicket,
  getCategoryInfo,
} from './ticket-form-actions';
import TicketToolbar from '../../components/form/ticket-toolbar';

const mapStateToProps = (state) => {
  const {
    ticketForm: {
      ticket,
      categoryInfo,
      categories,
      statuses,
      context,
      isLoading,
      isCommentsLoading,
      isSaving,
      priorities,
      isLoadingCategoryInfo,
      ticketStatusId,
      closingReasons,
      proposedActions,
    },
  } = state;

  return {
    ticket,
    categories,
    statuses,
    categoryInfo,
    context,
    isLoading,
    isCommentsLoading,
    isSaving,
    priorities,
    isLoadingCategoryInfo,
    ticketStatusId,
    closingReasons,
    proposedActions,
  };
};

const mapDispatchToProps = {
  createTicket,
  getCategoryInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketToolbar);
